import React from 'react'
import { P2Alert } from 'react-bootstrap-common-script'

function SaveDraftAlert() {
  return (
    <div style={{ marginTop: 24, marginBottom: 24 }}>
      <P2Alert variant={"success"} text={"Draft has been saved!"}></P2Alert>
    </div>
  )
}

export default SaveDraftAlert